module.exports = __webpack_public_path__ + "static/media/tyler_campaigne.b1504fab.png";